import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-list-item-label',
  template: '<ng-content />',
  styleUrls: ['list-item-label.component.scss']
})
export class ListItemLabelComponent {
}
